var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BusinessCrud',{attrs:{"title":"产品参数","columns":_vm.columns,"search-fields":_vm.searchFields,"form-fields":_vm.formFields,"list-api":_vm.getProductParamList,"save-api":_vm.saveProductParam,"delete-api":_vm.deleteProductParam,"defaults":{ isVisible: 1, sortOrder: 0 }}})
}
var staticRenderFns = []

export { render, staticRenderFns }